import styled from 'styled-components'
import * as _ from 'styles/helpers'
import type { Props } from './CardGridCN'
import getGridDimsCN, { GRID_GAP_CN } from '../CardGrid/utils/getGridDimsCN'

const StyledCardGridCN = styled.div<Partial<Props>>`
	.CardGridCN__header {
		margin-bottom: ${_.rem(GRID_GAP_CN)};
	}

	.CardGridCN__container {
		margin: auto;
	}

	.CardGridCN__grid {
		display: grid;
		gap: ${_.rem(GRID_GAP_CN)};
	}

	/* Mobile: 1 card per row */
	@media ${_.MQ.before_nav} {
		.CardGridCN__container {
			max-width: 100% !important;
			padding: 0 ${_.rem(8)};
		}

		.CardGridCN__grid {
			grid-template-columns: 1fr !important;
			gap: ${_.rem(8)} !important;
		}
	}

	&.grid-of-1 {
		.CardGridCN__container {
			max-width: ${_.rem(getGridDimsCN(1).maxWidth)};
		}
	}

	&.grid-of-2 {
		.CardGridCN__container {
			max-width: ${_.rem(getGridDimsCN(2).maxWidth)};
		}
		.CardGridCN__grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	&.grid-of-3 {
		.CardGridCN__container {
			max-width: ${_.rem(getGridDimsCN(3).maxWidth)};
		}
		.CardGridCN__grid {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	&.grid-of-4 {
		.CardGridCN__container {
			max-width: ${_.rem(getGridDimsCN(4).maxWidth)};
		}
		.CardGridCN__grid {
			grid-template-columns: repeat(4, 1fr);
		}
	}

	&.grid-of-5 {
		.CardGridCN__container {
			max-width: ${_.rem(getGridDimsCN(5).maxWidth)};
		}
		.CardGridCN__grid {
			grid-template-columns: repeat(5, 1fr);
		}
	}

	&.grid-of-6 {
		.CardGridCN__container {
			max-width: ${_.rem(getGridDimsCN(6).maxWidth)};
		}
		.CardGridCN__grid {
			grid-template-columns: repeat(6, 1fr);
		}
	}
`

export default StyledCardGridCN
